import { BrowserModule } from '@angular/platform-browser';
import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { MatAutocompleteModule, MatButtonModule, MatButtonToggleModule, MatCardModule, MatCheckboxModule, MatChipsModule, MatDatepickerModule, MatDialogModule, MatExpansionModule, MatGridListModule, MatIconModule, MatInputModule, MatListModule, MatMenuModule, MatNativeDateModule, MatPaginatorModule, MatProgressBarModule, MatProgressSpinnerModule, MatRadioModule, MatRippleModule, MatSelectModule, MatSidenavModule, MatSliderModule, MatSlideToggleModule, MatSnackBarModule, MatSortModule, MatTableModule, MatTabsModule, MatToolbarModule, MatTooltipModule, MatStepperModule } from '@angular/material';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule } from '@angular/common/http';

import { ToastrModule } from 'ngx-toastr';
import { CalendarModule } from 'angular-calendar';
import { CookieService } from 'ngx-cookie-service';
import { TypingAnimationModule } from 'angular-typing-animation'

import { AuthenticationService } from './services/authentication.service';
import { UsersService } from 'app/services/users.service';
import { TasksService } from './services/tasks.service';
import { FriendsService } from './services/friends.service';
import { ReportsService } from './services/reports.service';
import { NotificationsService } from './services/notifications.service';

import { AppComponent } from './app.component';
import { NavigationComponent } from './navigation/navigation.component';
import { SplashComponent } from './splash/splash.component';
import { LoginComponent } from './login/login.component';
import { RegisterComponent } from './register/register.component';
import { HomeComponent } from './home/home.component';
import { DashboardComponent } from './home/dashboard/dashboard.component';
import { CalendarComponent } from './home/calendar/calendar.component';
import { LearnComponent } from './learn/learn.component';
import { ProfileComponent, ConfirmDeleteDialog } from './profile/profile.component';
import { FriendsComponent } from './friends/friends.component';
import { LeaderboardComponent } from './leaderboard/leaderboard.component';
import { BlogComponent } from './learn/blog/blog.component';
import { HowItStartedComponent } from './learn/blog/posts/01/how-it-started.component';
import { ForgotPasswordComponent } from './login/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './login/reset-password/reset-password.component';
import { AdminComponent } from './reports/admin/admin.component';
import { NotificationComponent } from './notification/notification.component';
import { GetItDoneComponent } from './learn/blog/posts/02/get-it-done.component';

import { AuthGuard } from './guards/auth.guard';

const appRoutes: Routes = [
  { path: '', redirectTo:'/about', pathMatch: 'full' },
  { path: 'about', component: SplashComponent },
  { path: 'login', component: LoginComponent },
  { path: 'forgot-password', component: ForgotPasswordComponent },
  { path: 'register', component: RegisterComponent },
  { path: 'learn', component: LearnComponent },
  { path: 'blog', component: BlogComponent,
    children: [
      { path: 'how-it-started', component: HowItStartedComponent },
      { path: 'get-it-done', component: GetItDoneComponent }
    ]
  },
  { path: '', component: HomeComponent, canActivate: [AuthGuard],
    children: [
      { path: 'home', component: DashboardComponent },
      { path: 'calendar', component: CalendarComponent },
    ]
  },
  { path: 'leaderboard', component: LeaderboardComponent, canActivate: [AuthGuard] },
  { path: 'friends', component: FriendsComponent, canActivate: [AuthGuard] },
  { path: 'profile', component: ProfileComponent, canActivate: [AuthGuard] },
  { path: 'notifications', component: NotificationComponent, canActivate: [AuthGuard] },
  { path: 'admin', component: AdminComponent, canActivate: [AuthGuard] },
  { path: 'reset/:resetToken', component: ResetPasswordComponent }
];

const toastrPosition = (screen.width > 767) ? 'toast-bottom-full-width': 'toast-top-full-width'

@NgModule({
  declarations: [
    AppComponent,
    NavigationComponent,
    SplashComponent,
    LoginComponent,
    RegisterComponent,
    DashboardComponent,
    LearnComponent,
    ProfileComponent,
    CalendarComponent,
    HomeComponent,
    FriendsComponent,
    LeaderboardComponent,
    BlogComponent,
    HowItStartedComponent,
    ForgotPasswordComponent,
    ResetPasswordComponent,
    AdminComponent,
    NotificationComponent,
    ConfirmDeleteDialog,
    GetItDoneComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpModule,
    HttpClientModule,
    RouterModule.forRoot(
      appRoutes,
      { enableTracing: false } // <-- debugging purposes only
    ),
    BrowserAnimationsModule,
    ToastrModule.forRoot({
      timeOut: 2500,
      positionClass: toastrPosition,
      progressBar: true
    }),
    TypingAnimationModule,
    CalendarModule.forRoot(),
    MatAutocompleteModule, MatButtonModule, MatButtonToggleModule, MatCardModule, MatCheckboxModule, MatChipsModule, MatDatepickerModule, MatDialogModule, MatExpansionModule, MatGridListModule, MatIconModule, MatInputModule, MatListModule, MatMenuModule, MatNativeDateModule, MatPaginatorModule, MatProgressBarModule, MatProgressSpinnerModule, MatRadioModule, MatRippleModule, MatSelectModule, MatSidenavModule, MatSliderModule, MatSlideToggleModule, MatSnackBarModule, MatSortModule, MatTableModule, MatTabsModule, MatToolbarModule, MatTooltipModule, MatStepperModule
  ],
  providers: [
    CookieService,
    AuthGuard,
    AuthenticationService,
    UsersService,
    TasksService,
    FriendsService,
    ReportsService,
    NotificationsService
  ],
  bootstrap: [AppComponent],
  entryComponents: [ConfirmDeleteDialog]
})
export class AppModule { }



// WEBPACK FOOTER //
// /Users/cullenkirkpatrick/Documents/Goals/goal-project/src/app/app.module.ts